module.exports = __webpack_public_path__ + "img/aeroland-client-logo-11.17ffd15b.png";